import { render, staticRenderFns } from "./ResellerServiceListTable.vue?vue&type=template&id=1d483426"
import script from "./ResellerServiceListTable.vue?vue&type=script&lang=js"
export * from "./ResellerServiceListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports